import type { RecordingResult } from './api';

export const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * Recordings created more than `days` days before `now`; none when `days` is 0 (keep forever).
 * Callers pass finished recordings only (Recorder.listRecordings never lists one in progress).
 */
export function recordingsToPurge<T extends Pick<RecordingResult, 'createdAt'>>(list: readonly T[], days: number, now: number): T[] {
  if (!Number.isFinite(days) || days <= 0) return [];
  const cutoff = now - days * DAY_MS;
  return list.filter((r) => r.createdAt < cutoff);
}
